export interface IMetadataApi extends IPaginationMetadata {
  MetadataList: IMetadata[];
}

export interface IMetadata {
  Description: string;
  Id: string;
  PageType: EMetadataPageType;
  Sport: EMetadataSportsType;
  Title: string;
}
interface IPaginationMetadata {
  EndIndex: number;
  NumPages: number;
  Page: number;
  PageSize: number;
  StartIndex: number;
  Total: number;
}

export enum EMetadataPageType {
  HOME = 'HOME',
  TEAM = 'TEAM',
  COMPETITION = 'COMPETITION',
}

export enum EMetadataSportsType {
  BASEBALL = 'BASEBALL',
  BASKETBALL = 'BASKETBALL',
  FOOTBALL = 'FOOTBALL',
  HANDBALL = 'HANDBALL',
  ICE_HOCKEY = 'ICE_HOCKEY',
  AMERICAN_FOOTBALL = 'AMERICAN_FOOTBALL',
  VOLLEYBALL = 'VOLLEYBALL',
}
